import React from 'react';

const Select = ({date}) => {
    return (
        <select defaultValue={0} className="form-select select-btn">
            <option value="0">{date}</option>
            <option value="1">One</option>
            <option value="2">Two</option>
        </select>
    );
};

export default Select;